// src/components/UserAvatar/index.js
import React from 'react';
import { getColorForUsername } from 'components/utils/AvatarColor';
import { getDisplayName } from 'components/utils/AvatarColor';

const UserAvatar = ({ username, email, size = 32, className }) => {
  const displayName = getDisplayName({ username, email });
  const color = getColorForUsername(displayName);

  const initials = displayName
    ?.split(' ')
    .filter(Boolean)
    .map(word => word[0])
    .join('')
    .toUpperCase();

  return (
    <div
      className={className}
      style={{
        backgroundColor: color,
        color: '#fff',
        borderRadius: '50%',
        width: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: size / 2.5,
        fontWeight: 'bold',
      }}
      title={displayName}
    >
      {initials}
    </div>
  );
};

export default UserAvatar;
